import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=1f891954&scoped=true&"
import script from "./DynamicTable.vue?vue&type=script&lang=ts&"
export * from "./DynamicTable.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicTable.vue?vue&type=style&index=0&id=1f891954&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f891954",
  null
  
)

export default component.exports